import BaseModule from '@core/modules/base-module/base-module';
import TeaserSlider from '@pj/components/snap-sliders/teasers-snap-slider/teasers-snap-slider';

const teasersDesc = new BaseModule();
teasersDesc.name = 'teasers-desc';
teasersDesc.init((that)=>{
  const slider=new TeaserSlider();
  slider.init(that.elements);
});
